"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStorageImageObject = void 0;
function isStorageImageObject(value) {
    return !!(value && typeof value === 'object' && typeof value.path === 'string' && value.createdAt);
}
exports.isStorageImageObject = isStorageImageObject;
//# sourceMappingURL=StorageImageObject.js.map